import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

// NOTE: NSAI-7410 — a vector rendition of Microsoft Power BI's mark (a report
// frame over four bars on the brand yellow #f2c811, hsl 49 90% 51%), traced
// from Pipedream's raster logo (the vendored PNG renders first; this is the
// fallback). The near-black frame and bars are tinted from the same hue so the
// mark stays one brand colour family; they sit on the yellow tile, so they
// never meet a dark background.
const MicrosoftPowerBiComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="512"
      height="512"
      rx="56"
      fill="hsl(from hsl(49 90% 51%) h s 51%)"
    />
    <path
      d="M152,341.5H140.5A28,28 0 0 1 112.5,313.5V177.5A28,28 0 0 1 140.5,149.5H370.5A28,28 0 0 1 398.5,177.5V313.5A28,28 0 0 1 370.5,341.5H359"
      stroke="hsl(from hsl(49 90% 51%) h s 6%)"
      strokeWidth="14"
    />
    <path
      d="M187,308V352M234.5,254V352M281,281V352M328.5,207V352"
      stroke="hsl(from hsl(49 90% 51%) h s 6%)"
      strokeWidth="32"
      strokeLinecap="round"
    />
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components.
export const MicrosoftPowerBi = memo(MicrosoftPowerBiComponent);
